import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "./context/SiteContext";
import Home from "./pages/Home";
import CoursesPage from "./pages/ServicesPage";
import PsychologyPage from "./pages/PsychologyPage";
import SummerPage from "./pages/SummerPage";
import TeachersPage from "./pages/TeachersPage";
import GalleryPage from "./pages/GalleryPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
    return (
        <SiteProvider>
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    richColors
                    toastOptions={{
                        style: { fontFamily: "Manrope, sans-serif" },
                    }}
                />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/kurslar" element={<CoursesPage />} />
                    <Route path="/muellimler" element={<TeachersPage />} />
                    <Route path="/psixoloq" element={<PsychologyPage />} />
                    <Route path="/yay-proqrami" element={<SummerPage />} />
                    <Route path="/qalereya" element={<GalleryPage />} />
                    <Route path="/reyler" element={<ReviewsPage />} />
                    <Route path="/elaqe" element={<ContactPage />} />
                    {/* legacy redirects */}
                    <Route
                        path="/xidmetler"
                        element={<Navigate to="/kurslar" replace />}
                    />
                    <Route
                        path="/haqqimizda"
                        element={<Navigate to="/psixoloq" replace />}
                    />
                    <Route
                        path="/ugurlarimiz"
                        element={<Navigate to="/reyler" replace />}
                    />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </SiteProvider>
    );
}

export default App;
